"use client";

import * as React from "react";
import { Facebook, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu className="block max-w-full justify-start" viewport={false}>
      <NavigationMenuList className="flex-col items-start space-x-0 gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} className="w-full" data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium block w-full text-left">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark text-foreground py-16 border-t border-border/10 !bg-[hsl(239,35%,24%)]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559159/img/dclegal_logo_white.png" alt="DCLegal Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              DCLegal offre assistenza continuativa su numerose problematiche di diritto civile, 
              con particolare focus sulla contrattualistica d’impresa, assistendo i clienti 
              in ogni fase di negoziazione e accordo commerciale.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-serif font-semibold tracking-wide text-foreground">
              Link Rapidi
            </h3>
            <MenuProvider menu_id="43" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-serif font-semibold tracking-wide text-foreground">
              Aree di Attività
            </h3>
            <nav className="flex flex-col gap-3">
              {["Contrattualistica d'Impresa", "Diritto Societario", "Fusioni e Acquisizioni", "Real Estate", "Proprietà Intellettuale"].map((service, i) => <Link key={i} data-index={i} to="/SkillsPage" className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
                  {service}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-lg font-serif font-semibold tracking-wide text-foreground">
              Contatti
            </h3>
            <div className="flex flex-col gap-4 text-sm text-muted-foreground">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-primary shrink-0" />
                <span>Via San Vittore al Teatro 3 <br />20123 Milano (MI)</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary shrink-0" />
                <Link to="tel:+390612345678" className="hover:text-primary transition-colors">+39 02 496 75 955</Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary shrink-0" />
                <Link to="mailto:info@dclegal.it" className="hover:text-primary transition-colors">info@studiodclegal.it</Link>
              </div>
            </div>

            <div className="flex items-center gap-4 mt-2">
              {[{
              icon: Linkedin,
              href: "#"
            }, {
              icon: Twitter,
              href: "#"
            }, {
              icon: Facebook,
              href: "#"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} newTab className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary/10 text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300">
                  <social.icon className="w-4 h-4" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground/60">
          <p>
            &copy; {currentYear} DCLegal. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Cookie Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Note Legali
            </Link>
          </div>
        </div>
      </div>
    </section>;
}